module.exports = __webpack_public_path__ + "static/media/48373703_2308770972531414_4059307693213483008_o-thumb.283c0ef1.jpg";